import { SelectionSetTileDescription } from '@vp/swan'
import { useTranslation } from 'react-i18next'
import { FulfillmentStatus, getFulfillmentStatusLevel } from '@features/page/config/constants/fulfillment-status'
import type { FulfillmentStatusType } from '@features/page/config/constants/fulfillment-status'
import type { FulfillmentItem } from '@shared/types/fulfillment-history.types'
import type { Order } from '@shared/types'
import { formatGenericDate } from '@shared/utils/date.util'
import { getItemDateInfo } from '../../../../utils/order-selection.utils'

interface Props {
  order: Order
  fulfillment: FulfillmentItem | undefined
  locale: string
}

export const OrderItemTile = ({ order, fulfillment, locale }: Props) => {
  const { t } = useTranslation()

  const latestStatus = fulfillment?.history?.[0]?.status as FulfillmentStatusType | undefined
  const isUnavailable = !latestStatus || latestStatus === FulfillmentStatus.UNKNOWN
  const statusLabel = isUnavailable
    ? t('contact_us.page.steps.issue_description.statuses.UNKNOWN')
    : t(`contact_us.page.steps.issue_description.statuses.${latestStatus}`)
  const statusLevel = !isUnavailable ? getFulfillmentStatusLevel(latestStatus) : undefined
  const dateInfo = getItemDateInfo(latestStatus, fulfillment, order.orderData.orderCreationDate)

  return (
    <>
      <SelectionSetTileDescription
        fontSkin={isUnavailable ? 'body-standard' : 'body-standard-bold'}
        textColor={isUnavailable ? 'subtle' : statusLevel === 'error' ? 'error' : statusLevel === 'warning' ? 'warning' : 'success'}
      >
        {statusLabel}
      </SelectionSetTileDescription>
      {dateInfo && (
        <SelectionSetTileDescription fontSkin="body-standard" textColor="subtle">
          {t(dateInfo.labelKey)}
          {formatGenericDate(dateInfo.date, locale)}
        </SelectionSetTileDescription>
      )}
    </>
  )
}
